import { Card, CardContent } from "@/components/ui/card";

export const JobNotFound = () => (
  <Card className="max-w-3xl mx-auto">
    <CardContent className="py-8 text-center">
      <p className="text-muted-foreground">Job not found</p>
    </CardContent>
  </Card>
);